/*
 * ============================
 * File: base.js
 * Project: Octavia-Admin
 * File Created: Thursday, 9th April 2020 2:12:17 am
 * Author:UILIB
 * AuthorUrl:https://ui-lib.com/
 * -----
 * Last Modified: Monday, 13th April 2020 7:17:44 pm
 * Modified By: naime hossain (naime.hossain93@gmail.com)
 * -----
 * Copyright 2020 - 2021 UILIB, UILIB
 * ============================
 */

// Automatically loads and bootstraps files
// in the "./src/components/base" folder.

import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

// Vite uses import.meta.glob instead of require.context
const modules = import.meta.glob('@/components/base/**/*.vue', { eager: true })

export const registerBaseComponents = (app) => {
  for (const path in modules) {
    const componentConfig = modules[path]
    const name = path
      .replace(/^.*\/components\/base\//, '')
      .replace(/index.js/, '')
      .replace(/\.\w+$/, '')
    const componentName = upperFirst(camelCase(name))

    app.component(
      `Base${componentName}`,
      componentConfig.default || componentConfig,
    )
  }
}
